export enum EOperationScheduleType {
	ADD_REMOVE_MEAL_DEADLINE = 'ADD_REMOVE_MEAL_DEADLINE',
	CHANGE_ADDRESS_DEADLINE = 'CHANGE_ADDRESS_DEADLINE',
	CHANGE_DELIVERY_DATE_DEADLINE = 'CHANGE_DELIVERY_DATE_DEADLINE',
	MEAL_SELECTION_CHANGE_DEADLINE = 'MEAL_SELECTION_CHANGE_DEADLINE',
	ORDER_DEADLINE = 'ORDER_DEADLINE',
}
